<template>
  <v-card>
    <alert-error :error="error"></alert-error>
    <v-card-text>
      <users-tag-form v-model="userTags" :tags="tags || []">
        <template v-if="personalInterests.length" v-slot:additional>
          <span class="v-label">
            {{ $t('PERSONAL_INTERESTS.ADDITIONAL') }}:
            {{ personalInterests.map(el => el.interest).join(', ') }}
          </span>
        </template>
        <template v-if="showButtons" v-slot:buttons="{ valid }">
          <v-btn
            outlined
            class="mr-5"
            depressed
            color="grey"
            large
            @click="cancel"
          >
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-btn
            depressed
            type="submit"
            :disabled="!valid"
            large
            color="success"
            class="mr-5"
            @click.prevent="update"
          >
            {{ $t('BUTTON.UPDATE') }}
          </v-btn>
        </template>
      </users-tag-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash';
import { mapActions } from 'vuex';

export default {
  name: 'UsersTagPage',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    UsersTagForm: () => import('@/modules/tags/components/UsersTagForm.vue')
  },

  props: {
    userId: {
      type: Number,
      required: true
    },
    personId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    unwatch: null,
    locale: '',
    copyUserTags: [],
    userTags: [],
    tags: [],
    personalInterests: [],
    error: null,
    valid: true,
    showButtons: false
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  watch: {
    userTags: {
      deep: true,
      handler: 'checkUserTags'
    }
  },

  created() {
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.getTags();
        }
      }
    );
    this.getUserTags();
    this.getTags();
    this.getPersonalInterests();
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    ...mapActions('person', ['retrievePersonInterests']),

    getTags() {
      this.$store
        .dispatch('tag/retrieveTags')
        .then(({ data }) => {
          this.tags = data.data;
        })
        .catch(error => {
          this.error = error.response;
        });
    },
    getUserTags() {
      this.$store
        .dispatch('tag/retrieveUserTags', this.userId)
        .then(({ data }) => {
          this.userTags = data;
          this.copyUserTags = cloneDeep(this.userTags);
        })
        .catch(error => {
          this.error = error.response;
        });
    },
    getPersonalInterests() {
      this.retrievePersonInterests(this.personId)
        .then(({ data }) => {
          this.personalInterests = data.data;
        })
        .catch(error => {
          this.error = error.response;
        });
    },
    update() {
      this.$store
        .dispatch('tag/assign', {
          user_id: this.userId,
          userTags: this.userTags
        })
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('success', data);
          this.copyUserTags = cloneDeep(this.userTags);
          this.showButtons = false;
        })
        .catch(error => {
          this.error = error.response;
        });
    },
    cancel() {
      this.userTags = cloneDeep(this.copyUserTags);
      this.error = null;
    },
    checkUserTags(val) {
      this.showButtons =
        JSON.stringify(this.copyUserTags) !== JSON.stringify(val);
    }
  }
};
</script>
